import {makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme : Theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      cursor: 'pointer'
    },
    logo: {
      width: '100%'
    }
  }),
);

export default useStyles